/** Money sorted as a number rather than as the decimal string it travels as.
 *
 *  `'900.00'` sorts above `'10000.00'` lexically, which is the one way a money
 *  column can be wrong while looking right. Only the COMPARISON parses; every
 *  cell still prints the server's own string, so AD-9's "never a float" holds. */
export function byDecimal<T>(read: (row: T) => string) {
  return (a: { original: T }, b: { original: T }) =>
    Number(read(a.original)) - Number(read(b.original))
}
